// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"cf6d1e6e","254":"4660c486","255":"051fa028","308":"4ac9dac2","351":"ed5ace36","453":"e4955c82","495":"1111ab70","565":"3b3c5aee","590":"2d082194","620":"65bd7e63","708":"ba4f5d32","937":"1e080699","960":"7a77e794","988":"ccc1673e"}[chunkId] + ".chunk.js";
};